/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * inventory_type object
 * @export
 * @interface PostUniverseIdsInventoryType
 */
export interface PostUniverseIdsInventoryType {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsInventoryType
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsInventoryType
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsInventoryType interface.
 */
export function instanceOfPostUniverseIdsInventoryType(value: object): value is PostUniverseIdsInventoryType {
    return true;
}

export function PostUniverseIdsInventoryTypeFromJSON(json: any): PostUniverseIdsInventoryType {
    return PostUniverseIdsInventoryTypeFromJSONTyped(json, false);
}

export function PostUniverseIdsInventoryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsInventoryType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsInventoryTypeToJSON(json: any): PostUniverseIdsInventoryType {
    return PostUniverseIdsInventoryTypeToJSONTyped(json, false);
}

export function PostUniverseIdsInventoryTypeToJSONTyped(value?: PostUniverseIdsInventoryType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

